import { render, staticRenderFns } from "./control.vue?vue&type=template&id=4b6f0224&scoped=true"
import script from "./control.vue?vue&type=script&lang=js"
export * from "./control.vue?vue&type=script&lang=js"
import style0 from "./control.vue?vue&type=style&index=0&id=4b6f0224&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f0224",
  null
  
)

export default component.exports